import LookupAliases from '../components/LookupAliases';

const columns = [
    { accessorKey: 'stateName', header: 'State', meta: { sortBy: 'StateName', relatedFields: ['stateId', 'enerexLoadZoneId', 'enerexIdentifier', 'enerexStateIdentifier'] }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'name', header: 'Name', meta: { sortBy: 'Name' }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'aliases', header: 'Aliases', meta: { sortBy: 'Aliases' }, cell: ({ getValue, row }) => <LookupAliases value={getValue()} recordName={row.original.name || 'Load Zone'} /> },
];
export default columns;
